import { addNotification } from 'reapop';
import isArray from 'lodash/isArray';

export const setGlobalErrors = errors =>
  addNotification({
    message: isArray(errors) ? errors.join('<br/>') : errors,
    position: 'tc',
    status: 'error',
    dismissAfter: 5000,
    allowHTML: isArray(errors)
  });

export const setGlobalWarnings = warnings =>
  addNotification({
    message: isArray(warnings) ? warnings.join('<br/>') : warnings,
    position: 'tc',
    status: 'warning',
    dismissAfter: 5000,
    allowHTML: isArray(warnings)
  });

export const setGlobalSuccesses = successes =>
  addNotification({
    message: isArray(successes) ? successes.join('<br/>') : successes,
    position: 'tc',
    status: 'success',
    dismissAfter: 5000,
    allowHTML: isArray(successes)
  });

export const dispatchSessionMessages = (dispatch, sessionMessages) => {
  if (isArray(sessionMessages)) {
    return dispatch(setGlobalWarnings(sessionMessages));
  }

  return Object.keys(sessionMessages).forEach(errorType => {
    const msg = sessionMessages[errorType];

    switch (errorType) {
      case 'error':
        dispatch(setGlobalErrors(msg));
        break;
      case 'success':
        dispatch(setGlobalSuccesses(msg));
        break;
      case 'warning':
        dispatch(setGlobalWarnings(msg));
        break;
      default:
        dispatch(setGlobalWarnings(msg));
        break;
    }
  });
};
